import paths from '@/paths';

/** Organization task-type settings, the destination of the top-nav Tasks tab. */
const TASK_TYPES_SETTINGS_PATH = '/settings/organization/task-types';

export type HeaderNavAccess = {
  admin: boolean;
  isRestrictedUser: boolean;
  canReadBackgroundAgents: boolean;
  canReadTasks: boolean;
  tasksEnabled: boolean;
  /** Kill switch: hides the growth tabs that only lead to a preview. */
  hideFeatureSignups: boolean;
};

/**
 * Where each top-nav tab links for this user, or null when it is hidden. A
 * tab the user can't use yet links to its feature preview, unless the
 * `hide-feature-signups` kill switch is on.
 */
export function headerNavLinks(access: HeaderNavAccess) {
  const growthTabs = !access.hideFeatureSignups && !access.isRestrictedUser;
  const tasksReady = access.tasksEnabled && access.canReadTasks;
  return {
    agents: access.canReadBackgroundAgents
      ? paths.authenticated.backgroundAgents.list
      : growthTabs
        ? paths.authenticated.featurePreviews.agents
        : null,
    // Task-type settings where the org has Tasks; the preview otherwise.
    tasks: tasksReady
      ? TASK_TYPES_SETTINGS_PATH
      : growthTabs
        ? paths.authenticated.featurePreviews.tasks
        : null,
    workflows: access.admin
      ? paths.authenticated.workflows.list
      : growthTabs
        ? paths.authenticated.featurePreviews.workflows
        : null,
  };
}
